/**
 * @file externalAppLinks.js
 * @description Builds app links that are opened outside the app (emails, SMS) and reads which
 * client they belong to, so a link always opens in its own client's session.
 */

const COMPANY_CODE_PARAM = 'companyCode';
const UNSET_STORAGE_VALUES = ['undefined', 'null'];

function normalizeCompanyCode(companyCode) {
    return typeof companyCode === 'string'
        ? companyCode.trim().toLowerCase()
        : '';
}

function getActiveCompanyCode() {
    const companyCode = localStorage.getItem('companyCode');

    return companyCode && !UNSET_STORAGE_VALUES.includes(companyCode)
        ? companyCode
        : null;
}

export function readLinkCompanyCode(search) {
    return new URLSearchParams(search).get(COMPANY_CODE_PARAM) || null;
}

export function removeLinkCompanyCode(search) {
    const searchParams = new URLSearchParams(search);
    searchParams.delete(COMPANY_CODE_PARAM);
    const query = searchParams.toString();

    return query ? `?${query}` : '';
}

export function isSameCompanyCode(firstCompanyCode, secondCompanyCode) {
    const first = normalizeCompanyCode(firstCompanyCode);

    return first !== '' && first === normalizeCompanyCode(secondCompanyCode);
}

export function buildExternalAppUrl(routePath) {
    const url = new URL(routePath, window.location.origin);
    const companyCode = getActiveCompanyCode();

    if (companyCode) {
        url.searchParams.set(COMPANY_CODE_PARAM, companyCode);
    }

    return url.toString();
}
